/**
 * Cliente HTTP de «Comparar campañas» (`GET /activa/oficial/campanas/comparativa`): mismo camino que `estadisticasApi`
 * (`req()` de campana-nueva y `qs`), sin `brandId` (el tenant sale del token). Archivo aparte de `api.ts`, que lo editan
 * otros frentes de trabajo.
 */

import { req } from "../campana-nueva/api";
import { qs } from "./api";
import type { Resp } from "./api";
import type { EstadoCampanaOficial } from "./types";
import type { RangoFechas } from "./types.estadisticas";
import type { ComparativaCampanas } from "./types.comparativa";

export const comparativaApi = {
  /** Sin rango, el backend usa los últimos 30 días; sin estado, todas las que mandaron algo. */
  campanas: (rango?: Partial<RangoFechas>, estado?: EstadoCampanaOficial): Promise<Resp<ComparativaCampanas>> =>
    req("GET", `/activa/oficial/campanas/comparativa${qs({ desde: rango?.desde, hasta: rango?.hasta, estado })}`),
};
